export const footerLinks = [
    { href: '#about', text: 'About' },
    { href: '#skills', text: 'Skills' },
    { href: '#works', text: 'Projects' },
    { href: '#contact', text: 'Contact' },
];

export const socialIcons = [
    { href: 'https://linkedin.com/in/stelmaszczykadrian', iconClass: 'bx bxl-linkedin' },
    { href: 'https://github.com/stelmaszczykadrian', iconClass: 'bx bxl-github' },
    { href: 'mailto:stelmaszczykadrian@gmail.com', iconClass: 'uil uil-envelope' },
];

